export interface FlagProjectsReportSummary {
    id: number;
    completedDate: string;
    dataJson: string;
}

export interface FlagProjectsReportDetail {
    id: number;
    completedDate: string;
    totalProjectsProcessed: number;
    flaggedProjectsCount: number;
    projectsToValidateCount: number;
    unflaggedCount: number;
    lockedCount: number;
    advancedCount: number;
    newlyFlaggedCount: number;
    validCount: number;
    errorsCount: number;
    processingDetails: ProjectProcessingDetail[];
}

export interface ProjectProcessingDetail {
    projectId: string;
    projectName: string;
    costCenter: string;
    action: string;
}

export type ProjectAction = "Unflagged" | "Locked" | "FlagAdvanced" | "NewlyFlagged" | "Valid" | "NoChange" | "Error";

export const getProjectActionLabel = (action: string): string => {
    switch (action) {
        case "Unflagged":
            return "Unflagged";
        case "Locked":
            return "Locked";
        case "FlagAdvanced":
            return "Flag Advanced";
        case "NewlyFlagged":
            return "Newly Flagged";
        case "Valid":
            return "Valid";
        case "NoChange":
            return "No Change";
        case "Error":
            return "Error";
        default:
            return action || "Unknown";
    }
};
